import axios from 'axios';
const showroomVal =JSON.parse(localStorage.getItem('my_item'))
export default {
    namespaced: true,


    state: {
        ProjectExtraInfoData: null,
        SettingData: null,
        PendingNotificationsData: null,
        NotificationsData: null,
        NewLayout:localStorage.getItem('new-layout')?localStorage.getItem('new-layout'): 'No',
        // SubCategoryList: localStorage.getItem('subCategory') ? JSON.parse(localStorage.getItem('subCategory')):[],
        Breadcrumb: localStorage.getItem('breadcrumb')? JSON.parse(localStorage.getItem('breadcrumb')):{
            parent:'',
            child:'',
            product:'',
        },


        Category:localStorage.getItem('category')? JSON.parse(localStorage.getItem('category')):{
            parent:'',
            sub:'',
            list:'',
        },
        MyItem:{
            showroom:showroomVal?showroomVal.showroom:'',
            vsd_id:showroomVal?showroomVal.vsd_id:'',
            theme_color:showroomVal?showroomVal.theme_color:'',
            custom_addon:showroomVal?showroomVal.custom_addon:'',
            basic_addon:showroomVal?showroomVal.basic_addon:''
        },
        ProductCategory: localStorage.getItem('product_category')? JSON.parse(localStorage.getItem('product_category')):{
            category_id:'',
            category_name:'',
        },
       ShowRoom:localStorage.getItem('showroom')? JSON.parse(localStorage.getItem('showroom')):[],
        ProductList: localStorage.getItem('product_list')? JSON.parse(localStorage.getItem('product_list')):{
            product:'',

        },
        UserLogin:localStorage.getItem('user_login')?localStorage.getItem('user_login'):false,
        TopProduct:localStorage.getItem('top_product')? JSON.parse(localStorage.getItem('top_product')):{
            showroom:'',
            category:'',
        },
        CustomerViewed:localStorage.getItem('customer_viewed')? JSON.parse(localStorage.getItem('customer_viewed')):{
            showroom:'',
            category:'',
        },
        RecentlyViewed:localStorage.getItem('recently_viewed')? JSON.parse(localStorage.getItem('recently_viewed')):{
            showroom:'',
            category:'',
        },
        Pagination:localStorage.getItem('pagination')? JSON.parse(localStorage.getItem('pagination')): {
            paginationLink:'',
            nextUrl:'',
            prevUrl :'',
            total :'',
            current_page :'',
            prePage :''
        },
        ParentCategory: localStorage.getItem('ParentCategory')? localStorage.getItem('ParentCategory'):'',
        SubCategory:localStorage.getItem('SubCategory')?localStorage.getItem('SubCategory'):  '',
        SecondSubCategory:localStorage.getItem('SecondSubCategory')?localStorage.getItem('SecondSubCategory'): '',


    },

    getters: {
        ProjectExtraInfo: (state) => state.ProjectExtraInfoData,
        Setting: (state) => state.SettingData,
        PendingNotification: (state) => state.PendingNotificationsData,
        Notifications: (state) => state.NotificationsData,
        NewLayout: (state) => state.NewLayout,
        SubCategoryList:(state)=>state.SubCategoryList,
        Breadcrumb: (state)=> state.Breadcrumb,
        MyItem:(state)=>state.MyItem,
        ShowRoom:(state)=> state.ShowRoom,
        Category:(state)=>state.Category,
        ProductCategory:(state)=> state.ProductCategory,
        ProductList:(state)=>state.ProductList,
        UserLogin:(state)=>state.UserLogin,
        TopProduct:(state)=>state.TopProduct,
        CustomerViewed:(state)=>state.CustomerViewed,
        RecentlyViewed:(state)=>state.RecentlyViewed,
        Pagination:(state)=>state.Pagination,
        ParentCategory:(state)=>state.ParentCategory,
        SubCategory:(state)=>state.SubCategory,
        SecondSubCategory:(state)=> state.SecondSubCategory

    },

    mutations: {
        setProjectExtraInfoData(state, ProjectExtraInfo) {
            state.ProjectExtraInfoData = ProjectExtraInfo;
        },
        setSettingData(state, Setting) {
            state.SettingData = Setting;
        },
        setPendingNotificationsData(state, Notification) {
            state.PendingNotificationsData = Notification;
        },
        setNotificationsData(state, Notification) {
            state.NotificationsData = Notification;
        },
        setNewLayout(state, NewLayout) {
            state.NewLayout = NewLayout;
        },
        setSubCategoryList(state,SubCategoryList){
            state.SubCategoryList=SubCategoryList;
        },
        setBreadcrumb(state,Breadcrumb){
            state.Breadcrumb=Breadcrumb
        },

        setMyItem(state,MyItem){
            state.MyItem=MyItem
        },
        setCategory(state,Category){
            state.Category=Category
        },
        setShowRoom(state,ShowRoom){
            state.ShowRoom=ShowRoom
        },
        setProductCategory(state,ProductCategory){
            state.ProductCategory=ProductCategory
        },
        setProductList(state,ProductList){
            state.ProductList=ProductList
        },
        setUserLogin(state,UserLogin){
            state.UserLogin=UserLogin
        },
        setTopProduct(state,TopProduct){
            state.TopProduct=TopProduct
        },
        setCustomerView(state,CustomerViewed){
            state.CustomerViewed=CustomerViewed
        },
        setRecentlyViewed(state,RecentlyViewed){
            state.RecentlyViewed=RecentlyViewed
        },
        setPagination(state,Pagination){
            state.Pagination=Pagination
        },
        setParentCategory(state,ParentCategory){
            state.ParentCategory=ParentCategory
        },
        setSubCategory(state,SubCategory){
            state.SubCategory=SubCategory
        },
        setSecondSubCategory(state,SecondSubCategory){
            state.SecondSubCategory=SecondSubCategory
        }
    },

    actions: {
  

          fetchShop({ commit }) {
            try {
              
                
                axios
                .get("/api/visualization/shop_profile", {
                    params: {
                        vsd_id:shop_id,
                    }
                })
                .then(res => {
                    if (_.isEmpty(res.data)) {
                        loaderd.hide();
                        Toast.fire({
                            icon: "warning",
                            title:
                                "No Showroom Found, Please Enter Correct Showroom Id."
                        });
                    } else { 
                        let at=  res.data.data;
                        localStorage.setItem('showroom',JSON.stringify(at));
                        commit('setShowRoom',at)

                        let ct= {
                            parent: "all",
                            sub: "",
                            list: res.data.data.category,
                            type: "parent"
                        };
                        localStorage.setItem('category',JSON.stringify(ct));
                        commit('setCategory',ct)

                        let itm= {
                            showroom: res.data.data.profile.user_id,
                            vsd_id:shop_id
                        }
                        commit('updateMyItem', itm);
                        
                    }
                })







              
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          },



        getProjectExtraInfoData({ commit }, data) {
            var project = 0;
            if (data && data.id) {
                project = data.id;
            } else {
                project = parseInt(localStorage.getItem('project')) || 0;
            }

            axios.get('/api/projectCart/' + project).then((response) => {
                commit('setProjectExtraInfoData', response.data.data);
            });
        },
        SaveProjectExtraInfoData({ commit }, data) {
            commit('setErrors', {}, { root: true });
            let project = parseInt(localStorage.getItem('project')) || 0;
            return axios.put('/api/projectCart/' + project, data).then((response) => {
                if (response) {
                    if (
                        response.data.data.extra_info &&
                        response.data.data.extra_info != '' &&
                        response.data.data.extra_info != null
                    ) {
                        commit('setProjectExtraInfoData', true);
                    } else {
                        commit('setProjectExtraInfoData', false);
                    }
                }
            });
        },
        getSettingData({ commit }) {
            axios.get('/api/setting').then((response) => {
                commit('setSettingData', response.data.data);
            });
        },

        getPendingNotifications({ commit }) {
            axios
                .get('/api/notification', {
                    params: {
                        pending: 1,
                    },
                })
                .then((response) => {
                    commit('setPendingNotificationsData', response.data.data);
                });
        },

        async getNotifications({ commit }, data) {
            let url = data.url ? data.url : '/api/notification';
            delete data.url;
            axios.get(url, { params: data }).then((response) => {
                commit('setNotificationsData', response.data.data);
            });
        },
        updateNotification({ commit }, data) {
            axios.put('/api/notification/' + data.id, data).then((response) => {
                // commit("setSettingData", response.data.data);
            });
        },
        updateNewLayout({ commit }, data) {
            localStorage.setItem('new-layout', data)
            commit('setNewLayout', data);
        },
        updateSubCategory({commit},data){

            localStorage.setItem('subCategory', JSON.stringify(data))
            commit('setSubCategoryList',data)

        },
        updateBreadcrumb({commit},data){
            localStorage.setItem('breadcrumb', JSON.stringify(data))
            commit('setBreadcrumb',data)
        },

        updateMyItem({commit},data){
            localStorage.setItem('my_item',JSON.stringify(data));
            commit('setMyItem',data)

        },
        AddItemShowroom({commit},data){
            localStorage.setItem('showroom',JSON.stringify(data));
            commit('setShowRoom',data)
        },
        updateCategory({commit},data){
            localStorage.setItem('category',JSON.stringify(data));
            commit('setCategory',data)
        },
        updateProductCategory({commit},data){
            localStorage.setItem('product_category',JSON.stringify(data));
            commit('setProductCategory',data)
        },
        AddProduct({commit},data){
            localStorage.setItem('product_list',JSON.stringify(data));
            commit('setProductList',data)
        },
        checkUserLogin({commit},data){
            localStorage.setItem('user_login',data)
            commit('setUserLogin',data)

        },
        setTopProduct({commit},data){
           axios.post('/api/top_products/',data).then((res)=>{
               localStorage.setItem('top_product',JSON.stringify(res.data.data))
               commit('setTopProduct',res.data.data)
           }).catch((error)=>{
               console.log(error)
           })
        },

        setCustomerView({commit},data){
            axios.post('/api/customer_also_viewed/',data).then((res)=>{
                localStorage.setItem('customer_viewed',JSON.stringify(res.data.data))
                commit('setCustomerView',res.data.data)
            }).catch((error)=>{
                console.log(error)
            })
        },
        setRecentlyViewed({commit},data){
            axios.post('/api/recently_viewed/',data).then((res)=>{
                localStorage.setItem('recently_viewed',JSON.stringify(res.data.data))
                commit('setRecentlyViewed',res.data.data)
            }).catch((error)=>{
                console.log(error)
            })

        },

        setPagination({commit},data) {
            localStorage.setItem('pagination',JSON.stringify(data))
            commit('setPagination',data)

        },
        setParentCategory({commit},data) {
            localStorage.setItem('ParentCategory',data)
            commit('setParentCategory',data)
        },
        setSubCategory({commit}, data) {
            localStorage.setItem('SubCategory',data)
            commit('setSubCategory',data)
        },
        setSecondSubCategory({commit},data) {
            localStorage.setItem('SecondSubCategory',data)
            commit('setSecondSubCategory',data)
        }


    },
};
